var React = require('react');

function Drumstick (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M193.7 392.5c-9.7 9.8-11.1 24-6 36.8 12.4 30.9-2.6 66-33.6 78.4-22.4 9-48.1 3.7-65.2-13.4-15.3-15.3-19.6-36.5-15.1-56.1-19.6 4.5-40.8.2-56.1-15.1-23.6-23.5-23.7-61.7-.2-85.3 17.1-17.2 42.7-22.4 65.2-13.4 12.8 5.1 27 3.7 36.8-6l40.5-40.5V288c0 35.3 28.7 64 64 64h10.2l-40.5 40.5z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M160.1 192c0-64 27.6-107 63.1-142.4 66.1-66.1 173.2-66 239.3 0s66 173.2 0 239.3C427 324.3 384 352 320.1 352H224c-35.3 0-64-28.7-64-64l.1-96z","className":"fa-primary","key":2})]);
}

Drumstick.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Drumstick;

Drumstick.default = Drumstick;
